import { Popup } from '../../../../../ui/popup/popup';

interface IReferRecurringCreditPopup {
    close: Function;
    isShoppingCart: boolean;
}

const ReferRecurringCreditPopup = (props: IReferRecurringCreditPopup) => {

    const { close, isShoppingCart } = props;

    const closePopup = () => {
        close();
    };

    return (
        <Popup width="450px" height="300px" close={ closePopup }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mt-4 mb-2 text-xl">Redeem Rewards on Recurring Payments</p>
                <p className="mb-4 px-6">
                    Redeem rewards towards recurring monthly/annual subscription payments until the rewards finish.<br/>
                    {
                        isShoppingCart &&
                        <>
                            You can manage this option in your account’s<br/> <a href="/account/products#subscriptions">My Products</a> page.<br/>
                        </>
                    }
                    <a href="/legal/waves-refer-a-friend-program-terms-conditions">See terms & conditions</a>.
                </p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ closePopup }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default ReferRecurringCreditPopup;